import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import React from 'react';
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Form,
  Input,
  Col,
  FormGroup,
  InputGroup
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
  import "../../assets/css/custom.css";
  import Header from "../../components/Headers/Header.js";
import 'assets/css/themecustom-style.css';
import '@flowjs/flow.js';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import ReactDatetime from "react-datetime";
import { usermanageService } from "../../services/usermanageService";
const axios = require("axios");

const EWSMaster = (props) => {
  const [clientsearch, setclientsearch] = useState('');
  const [trans_data,settransData] = useState([]);
  const [state, setState] = useState({});
  const [disablestate, setdisablestate] = useState(false);
  const [newbox, setNewBox] = useState(0);
  const [defaultkey, setdefaultKey] = useState(0);
  const [eligibility, setEligible] = useState(1);
  const [month, setMonth] = useState();
  const history = useHistory();
  
useEffect(() => {
    showEWSMaster();
}, []);

const user_info = JSON.parse(localStorage.getItem("user-info"));

function showEWSMaster(user=''){
    usermanageService.showEWSMaster(user).then((response) => {
      
        if(response.status === 200){
          console.log(response.data)
          settransData(response.data)
          setState(response.data)      
          setdefaultKey(response.data.length + 1)
          setNewBox(response.data.length + 1)
         
        }else {
          toast.error('Something went wrong!');
        }
    });
}

const companyfilter = (e,index) => {
  settransData([])
  setState({})      
 showKROMaster(e.value)
 setclientsearch(e.value)
};

function inputhandler(e,index) {

  let temp_st = {...state};
  let temp_ele = { ...temp_st[index] };
  temp_ele[e.target.name] = e.target.value;
  temp_ele['user_id'] = clientsearch;
  temp_st[index] = temp_ele;
  setState(temp_st);

}

function addsopform(e) {
  console.log(e);
  setdisablestate(true)
  e.preventDefault();
  usermanageService.updateEWSForm(state).then((response) => {
    if (response.status == 200) {
      toast.success(response.data.message);
      // location.reload();
    }
    setdisablestate(false)
  });
}

 
const addNewbox = ()=>{
  const setdata = newbox+1;
  setNewBox(setdata)
 
}
const removeBox = ()=>{
  if(newbox > 0){
    const setdata = newbox-1;
    setNewBox(setdata)
  }
 
 
}
const saveEligibility = (e) => {
  
  usermanageService.updateUserEligibility(eligibility,clientsearch,month).then((response) => {
    if (response.status == 200) {
      toast.success(response.data.message);
      // location.reload();
    }
    setdisablestate(false)
  });
}
const SetEligibility = (e) => {
  setEligible(e.target.value)
  
}
const krotyperating = ()=>{
  history.push("/admin/krotyperating/");
}
function inputhandler1(e,field) {
  if(field=='month'){
    setMonth(e.target.value)
  }

}
const archieveRows = (e,id) => {
  e.preventDefault();
  usermanageService.archiveewsmaster(id).then((response) => {
    if(response.status == 200){
     
        showEWSMaster()
     toast.success(response.data.message);
      
     
    }else{
      toast.error(response.data.message);
    }
  });
}
console.log(trans_data)
  return (
    <>
      <Header />
      <Container className="mt--7"  fluid>
      {/* <Row className="align-items-center row">
            <Col xl="10">
            
              <Button
                className="dash-button "
                color="primary"
                type="button"
                onClick={() => krotyperating()}
              >
                {" "}
              + Type Rating{" "}
              </Button>{" "}
             
            </Col>
            
                   
          </Row><br></br> */}
       
        <Row className="mt-12" >
          
        <Card className="shadow"  style={{width:"100%"}}>
          {(clientsearch != '') ? 
          <>
        <div className="row">
          <Col className="col-md-4">
              <FormGroup>
                <label>Select Eligibility</label>
                <select className="form-control" value={eligibility} name="target_type"   onChange={(e) => SetEligibility(e)}>
                          <option value="1">YES</option>
                          <option value="0">NO</option>
                </select>
              </FormGroup>
          </Col>
          {eligibility==0 ? 
          <Col className="col-md-4">
          <FormGroup>
                        <label>Select month</label>
                        <ReactDatetime
                                      inputProps={{
                                        placeholder: 'Select month',
                                        className: 'form-control',
                                        name: 'month',
                                        readOnly: true,
                                      }}
                                      dateFormat="YYYY-MM"
                                      timeFormat={false}
                                      closeOnSelect={true}
                                      value={month}
                                      onChange={(m) => {
                                        const val = m && m.format ? m.format('YYYY-MM') : '';
                                        inputhandler1({ target: { value: val, name: 'month' } }, 'month');
                                      }}
                                      />
                        
                                  
                             
                      </FormGroup> 
          </Col> : ''}
          <Col className="col-md-4" >
          <Button color="primary" style={{marginTop:'30px'}} className="col-xl-6"  type="button" onClick={saveEligibility} >
           Save Eligibility
              </Button>
          </Col>
        </div>
        
        </>
        : null }
            <Form
                role="form"
                id="phase-selection-form"
                onSubmit={addsopform}
            
              >
               
              <Table  className="align-items-center table-flush" responsive>
              <thead>
                <tr style={{ border: "1px solid #000" }}>
                  <th style={{ border: "1px solid #000" }}>Sr.No.</th>
                  <th style={{ border: "1px solid #000" }} className="whitespace">Name</th>
                  <th style={{ border: "1px solid #000" }} className="whitespace">Priority</th>
                  <th style={{ border: "1px solid #000" }} className="whitespace">% Weightage</th>
                  <th style={{ border: "1px solid #000" }} className="whitespace">Action</th>
                </tr>
              </thead>
                <tbody>
                {trans_data && trans_data.length && trans_data != null ? (
                    trans_data.map((item, i) =>
              <>
                  <tr className="whitespace" style={{border : "1px solid #000"}}>  
                  <td className="whitespace" style={{border : "1px solid #000"}}>{i+1}</td>
                    <td className="whitespace" style={{border : "1px solid #000"}}>
                    <Input
                            bsSize="sm"
                            name="name"
                            placeholder="name"
                            id="example-date-input"
                            type="text"
                            value={item.name}
                            onChange={(e) => inputhandler(e, i)}
                        />
                    </td>
                   
                    <td className="whitespace" style={{border : "1px solid #000"}}>
                    <Input
                            bsSize="sm"
                            name="priority"
                            placeholder="Priority"
                            id="example-date-input"
                            type="number"
                            value={item.priority}
                            onChange={(e) => inputhandler(e, i)}
                        />
                    </td>
                    <td className="whitespace" style={{border : "1px solid #000"}}>
                    <Input
                            bsSize="sm"
                            name="weightage"
                            placeholder="weightage"
                            id="example-date-input"
                            type="number"
                            value={item.weightage}
                            onChange={(e) => inputhandler(e, i)}
                        />
                    </td>
                    <td className="whitespace" style={{border : "1px solid #000"}}>
                    <Button className="btn btn-danger" onClick={(e) => { archieveRows(e,item.id);}}   class="btn btn-danger"><i class="fa fa-trash"></i></Button>
                    </td>
                  </tr>
              
                </>
            )
            ) : (
            null
            )}
            {(() => {
            const arr1 = [];
            for (let key = defaultkey; key < newbox; key++) {
                arr1.push(
                 <>
                  <tr className="whitespace" style={{border : "1px solid #000"}}>
                    <td style={{border : "1px solid #000"}}>{key}</td>
                    
                    <td style={{border : "1px solid #000"}}>
                      
                    <Input
                            bsSize="sm"
                            name="name"
                            placeholder="name"
                            id="example-date-input"
                            type="text"

                            onChange={(e) => inputhandler(e, key)}
                        />
                 
                      </td>
                     
                      <td className="whitespace"  style={{border : "1px solid #000"}}>
                        <Input
                            bsSize="sm"
                            name="priority"
                            placeholder="Priority"
                            id="example-date-input"
                            type="number"
                            onChange={(e) => inputhandler(e,key)}
                        />
                      </td>
                      <td className="whitespace"  style={{border : "1px solid #000"}}>
                        <Input
                            bsSize="sm"
                            name="weightage"
                            placeholder="Weightage"
                            id="example-date-input"
                            type="number"
                            onChange={(e) => inputhandler(e,key)}
                        />
                      </td>
                      <td className="whitespace" style={{border : "1px solid #000"}}>
                    <Button className="btn btn-danger" onClick={(e) => { removeBox();}}   class="btn btn-danger"><i class="fa fa-trash"></i></Button>
                    </td>
                  </tr>
                    </>
                );
            }
            return arr1;
            
        })()}
            </tbody>
              </Table>
              </Form>
            <br></br>
              
                <div class="d-flex">
                {/* <Button color="primary" className="col-xl-2" style={{flex:"0 0 4.66667%"}} type="button" onClick={(e) => addNewbox()} >
            <i class="fa fa-plus"></i>
              </Button> */}
            <Button color="primary" className="col-xl-2" style={{flex:"0 0 4.66667%"}} type="button" onClick={addsopform} disabled={disablestate}>
            {disablestate ? 'Sending...' : 'Save'} 
              </Button>
              </div>
              
             
              </Card>
              </Row>

      </Container>
    </>
  );
};

 
export default EWSMaster;
